export default function(count, paddingInner, paddingOuter) {
  var space = count - paddingInner + paddingOuter * 2;
  return count ? (space > 0 ? space : 1) : 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scale/src/bandSpace.js
// module id = 345
// module chunks = 0